import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink, FiMenu, FiX } from 'react-icons/fi';
import { useMobileMenu } from '../../../hooks/useMobileMenu';
import { useLanguage } from '../../../contexts/LanguageContext';
import { NavLinks } from './NavLinks';
import { MobileMenu } from './MobileMenu';
import { LanguageSelector } from './LanguageSelector';
import QuoteModal from '../Quote/QuoteModal';

const Header = () => {
  const [showQuote, setShowQuote] = useState(false);
  const { isOpen, toggle, close } = useMobileMenu();
  const { t } = useLanguage();

  const openQuoteModal = useCallback(() => {
    setShowQuote(true);
  }, []);

  const closeQuoteModal = useCallback(() => {
    setShowQuote(false);
  }, []);

  return (
    <header
      className="fixed top-0 z-50 w-full bg-white shadow-lg border-b-4 border-gradient-to-r from-primary via-secondary to-primary"
      role="banner"
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Ana navigasyon">
        <div className="flex items-center justify-between gap-4 py-3 sm:py-4">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" aria-label="TMR Global - Ana Sayfa">
            <img
              src="/img/tmr-logo.jpeg"
              alt="TMR Global Logo"
              width="140"
              height="140"
              loading="eager"
              className="rounded-lg w-32 sm:w-36 md:w-40 lg:w-44 h-auto"
            />
          </Link>

          {/* Desktop Navigation - Hidden on mobile/tablet */}
          <div className="hidden lg:flex flex-1 justify-center">
            <NavLinks />
          </div>

          {/* Desktop CTA & Language - Hidden on mobile/tablet */}
          <div className="hidden lg:flex items-center gap-4 flex-shrink-0">
            <button
              type="button"
              className="flex flex-col items-center bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all group"
              onClick={openQuoteModal}
              aria-label="Teklif formunu aç"
            >
              <span className="text-xs font-medium">{t('header.quickQuote')}</span>
              <div className="flex items-center gap-2">
                <span className="text-lg font-bold">{t('header.quote')}</span>
                <FiExternalLink className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </div>
            </button>
            <LanguageSelector />
          </div>

          {/* Mobile Language & Menu - Only visible on mobile/tablet */}
          <div className="lg:hidden flex items-center gap-2 flex-shrink-0">
            <LanguageSelector />
            <button
              type="button"
              className="p-3 rounded-lg hover:bg-gray-100 transition-colors touch-manipulation"
              onClick={toggle}
              aria-expanded={isOpen}
              aria-label={isOpen ? t('header.closeMenu') : t('header.openMenu')}
            >
              {isOpen ? (
                <FiX size={28} aria-hidden="true" />
              ) : (
                <FiMenu size={28} aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isOpen} onClose={close} onQuoteClick={openQuoteModal} />

      {/* Quote Modal */}
      <QuoteModal open={showQuote} onClose={closeQuoteModal} />
    </header>
  );
};

export default Header;
